import React, { useEffect } from "react";
import { Route, useLocation, useNavigate } from "react-router-dom";
import { Wrapper } from "../Components/Utils/roles";

import MainPayments from "../Views/Web/Payment/MainPayment";
import RefundsMain from "../Views/Web/Payment/Refunds/MainRefunds";
import PayablesMain from "../Views/Web/Payment/Payables/MainPayables";
import ReceivablesMain from "../Views/Web/Payment/Receivables/MainReceivables";

import RefundsIndex from "../Views/Web/Payment/Refunds";
import CreateRefunds from "../Views/Web/Payment/Refunds/CreateRefunds";
import EditRefunds from "../Views/Web/Payment/Refunds/EditRefunds";
import ViewRefunds from "../Views/Web/Payment/Refunds/ViewRefunds";
import PayablesIndex from "../Views/Web/Payment/Payables";
import CreatePayables from "../Views/Web/Payment/Payables/CreatePayables";
import EditPayables from "../Views/Web/Payment/Payables/EditPayables";
import ViewPayables from "../Views/Web/Payment/Payables/ViewPayables";
import ReceivablesIndex from "../Views/Web/Payment/Receivables";
import CreateReceivables from "../Views/Web/Payment/Receivables/CreateReceivables";
import EditReceivables from "../Views/Web/Payment/Receivables/EditReceivables";
import ViewReceivables from "../Views/Web/Payment/Receivables/ViewReceivables";
import AddPayableAmount from "../Views/Web/Payment/Payables/AddPayableAmount";
import EditPayableAmount from "../Views/Web/Payment/Payables/EditPayableAmount";
import AddReceivableAmount from "../Views/Web/Payment/Receivables/AddReceivableAmount";
import EditReceivableAmount from "../Views/Web/Payment/Receivables/EditReceivableAmount";


import BanksMain from "../Views/Web/Payment/Banks/MainBanks";
import BanksIndex from "../Views/Web/Payment/Banks";
import CreateBank from "../Views/Web/Payment/Banks/CreateBank";
import EditBank from "../Views/Web/Payment/Banks/EditBank";
import ViewBank from "../Views/Web/Payment/Banks/ViewBank";
import AgeingAnalysisIndex from "../Views/Web/Payment/AgeingAnalysis";


function PaymentRoutes() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (
            location.pathname === "/payments" ||
            location.pathname === "/payments/") {
            navigate("/page-not-found")
        }
    }, [location])
    return (

        <Route path="payments" element={<MainPayments />}>
            <Route path="payables" element={<PayablesMain />}>
                <Route index element={< Wrapper permissionKey={"payables_view"} Component={PayablesIndex} />} />
                <Route path="create" element={< Wrapper permissionKey={"payables_create"} Component={CreatePayables} />} />
                <Route path="edit/:payablesEditId" element={< Wrapper permissionKey={"payables_edit"} Component={EditPayables} />} />
                <Route path="view/:payablesViewId" element={< Wrapper permissionKey={"payables_view"} Component={ViewPayables} />} />
                <Route path="add/:amountPayableId" element={< Wrapper permissionKey={"payables_create"} Component={AddPayableAmount} />} />
                <Route path="edit/amount/:amountPayableEditId" element={< Wrapper permissionKey={"payables_edit"} Component={EditPayableAmount} />} />
            </Route>
            <Route path="receivables" element={<ReceivablesMain />}>
                <Route index element={< Wrapper permissionKey={"receivables_view"} Component={ReceivablesIndex} />} />
                <Route path="create" element={< Wrapper permissionKey={"receivables_create"} Component={CreateReceivables} />} />
                <Route path="edit/:receivablesEditId" element={< Wrapper permissionKey={"receivables_edit"} Component={EditReceivables} />} />
                <Route path="view/:receivablesViewId" element={< Wrapper permissionKey={"receivables_view"} Component={ViewReceivables} />} />
                <Route path="add/:amountReceivableId" element={< Wrapper permissionKey={"receivables_create"} Component={AddReceivableAmount} />} />
                <Route path="edit/amount/:amountReceivableEditId" element={< Wrapper permissionKey={"receivables_edit"} Component={EditReceivableAmount} />} />

            </Route>
            <Route path="banks" element={<BanksMain />}>
                <Route index element={< Wrapper permissionKey={"bank_details_view"} Component={BanksIndex} />} />
                <Route path="create" element={< Wrapper permissionKey={"bank_details_create"} Component={CreateBank} />} />
                <Route path="edit/:bankEditId" element={< Wrapper permissionKey={"bank_details_edit"} Component={EditBank} />} />
                <Route path="view/:bankViewId" element={< Wrapper permissionKey={"bank_details_view"} Component={ViewBank} />} />
            </Route>
            <Route path="bank-details" element={<BanksMain />}>
                <Route index element={< Wrapper permissionKey={"bank_details_view"} Component={BanksIndex} />} />
                <Route path="create" element={< Wrapper permissionKey={"bank_details_create"} Component={CreateBank} />} />
                <Route path="edit/:bankEditId" element={< Wrapper permissionKey={"bank_details_edit"} Component={EditBank} />} />
                <Route path="view/:bankViewId" element={< Wrapper permissionKey={"bank_details_view"} Component={ViewBank} />} />
            </Route>
            <Route path="refunds" element={<RefundsMain />}>
                <Route index element={< Wrapper permissionKey={"refunds_view"} Component={RefundsIndex} />} />
                <Route path="create" element={< Wrapper permissionKey={"refunds_create"} Component={CreateRefunds} />} />
                <Route path="edit/:refundsEditId" element={< Wrapper permissionKey={"refunds_edit"} Component={EditRefunds} />} />
                <Route path="view/:refundsViewId" element={< Wrapper permissionKey={"refunds_view"} Component={ViewRefunds} />} />
            </Route>
            <Route
                path="ageing-analysis"
                element={<Wrapper permissionKey={"ageing_analysis_view"} Component={AgeingAnalysisIndex} />}
            />
        </Route>
    )
}

export default PaymentRoutes;